// src/pages/admin/DisputesPage.jsx
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { adminDisputesApi } from '../../api/services'
import { Card, CardBody, StatusBadge, PageSpinner, Empty, Pagination } from '../../components/common/ui'

export default function DisputesPage() {
  const [status, setStatus] = useState('open')
  const [page, setPage] = useState(1)
  const { data, isLoading } = useQuery({ queryKey: ['admin-disputes', status, page], queryFn: () => adminDisputesApi.list({ status: status||undefined, page }) })
  const disputes = data?.data?.data?.disputes?.data || []
  const lastPage = data?.data?.data?.disputes?.last_page || 1

  return (
    <div>
      <h1 className="text-xl font-display font-bold mb-6">Disputes</h1>
      <div className="flex gap-2 mb-4 flex-wrap">
        {['','open','investigating','resolved','closed'].map(s => (
          <button key={s} onClick={() => { setStatus(s); setPage(1) }}
            className={`px-4 py-1.5 rounded-full text-xs font-bold border transition-all ${status === s ? 'bg-pink text-white border-pink' : 'border-border text-muted hover:border-pink'}`}>
            {s || 'All'}
          </button>
        ))}
      </div>
      {isLoading && <PageSpinner />}
      {!isLoading && disputes.length === 0 && <Empty icon="⚖️" title="No disputes" />}
      <div className="space-y-3">
        {disputes.map(d => (
          <Card key={d.id}>
            <CardBody className="flex items-center justify-between flex-wrap gap-3">
              <div>
                <div className="flex items-center gap-2"><span className="font-bold text-sm">{d.type?.replace(/_/g,' ')}</span><StatusBadge status={d.status} /></div>
                <p className="text-xs text-muted">Order: {d.order?.order_number} · {d.raised_by?.name}</p>
                <p className="text-xs text-muted">{new Date(d.created_at).toLocaleDateString('en-IN')}</p>
              </div>
              <Link to={`/admin/disputes/${d.id}`} className="text-xs text-pink hover:underline">Review →</Link>
            </CardBody>
          </Card>
        ))}
      </div>
      {lastPage > 1 && <div className="mt-6"><Pagination currentPage={page} lastPage={lastPage} onPageChange={setPage} /></div>}
    </div>
  )
}
